import React from 'react';

export default function EmptyContentIllustration(
  props: React.SVGAttributes<{}>
) {
  return (
    <svg
      width="80"
      height="115"
      viewBox="0 0 80 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M77.2281 91.9145L44.5242 110.798L7.69678 89.4848L40.4007 70.6055L77.2281 91.9145Z"
        fill="#232629"
      />
      <path
        opacity="0.5"
        d="M77.2281 91.9145L44.5242 110.798L7.69678 89.4848L40.4007 70.6055L77.2281 91.9145Z"
        fill="#FCFEFF"
      />
      <path
        d="M40.4007 45.0078V70.6044L7.69678 89.4837V63.8915L40.4007 45.0078Z"
        fill="#232629"
      />
      <path
        opacity="0.23"
        d="M40.4007 45.0078V70.6044L7.69678 89.4837V63.8915L40.4007 45.0078Z"
        fill="white"
      />
      <path
        d="M44.5242 85.2016V110.798L7.69678 89.4847V63.8926L44.5242 85.2016Z"
        fill="#232629"
      />
      <path
        opacity="0.38"
        d="M44.5242 85.2016V110.798L7.69678 89.4847V63.8926L44.5242 85.2016Z"
        fill="#CED9E4"
      />
      <path
        d="M77.2283 66.3169V91.9135L40.4009 70.6044V45.0078L77.2283 66.3169Z"
        fill="#232629"
      />
      <path
        opacity="0.4"
        d="M77.2283 66.3169V91.9135L40.4009 70.6044V45.0078L77.2283 66.3169Z"
        fill="white"
      />
      <path
        d="M77.2288 91.913V66.3164L44.5249 85.2001V110.797L77.2288 91.913Z"
        fill="#232629"
      />
      <path
        opacity="0.23"
        d="M77.2288 91.913V66.3164L44.5249 85.2001V110.797L77.2288 91.913Z"
        fill="#CED9E4"
      />
      <path
        d="M40.4009 45.0085L40.4452 30.8379L77.1839 52.1736L77.2283 66.3175L40.4009 45.0085Z"
        fill="#232629"
      />
      <path
        opacity="0.2"
        d="M40.4009 45.0085L40.4452 30.8379L77.1839 52.1736L77.2283 66.3175L40.4009 45.0085Z"
        fill="#2D2F34"
      />
      <path
        d="M44.5249 85.2016L47.5931 72.8046L80 54.0938L77.2288 66.3178L44.5249 85.2016Z"
        fill="#232629"
      />
      <path
        opacity="0.3"
        d="M44.5249 85.2016L47.5931 72.8046L80 54.0938L77.2288 66.3178L44.5249 85.2016Z"
        fill="#CED9E4"
      />
      <path
        d="M7.69718 63.8937L3.79541 51.0355L36.4993 32.1562L40.4011 45.01L7.69718 63.8937Z"
        fill="#232629"
      />
      <path
        opacity="0.1"
        d="M7.69718 63.8937L3.79541 51.0355L36.4993 32.1562L40.4011 45.01L7.69718 63.8937Z"
        fill="#2D2F34"
      />
      <path
        d="M7.69713 63.8935L0 53.2656L36.8318 74.5747L44.5245 85.2026L7.69713 63.8935Z"
        fill="#232629"
      />
      <path
        opacity="0.45"
        d="M7.69713 63.8935L0 53.2656L36.8318 74.5747L44.5245 85.2026L7.69713 63.8935Z"
        fill="#CED9E4"
      />
      <path
        opacity="0.7"
        d="M0 53.2656L36.8318 74.5747L44.5245 85.2026L36.4239 74.9516L0 53.2656Z"
        fill="white"
      />
      <path
        opacity="0.7"
        d="M77.2288 66.3164L44.5249 85.2001V110.797L45.1368 85.7145L77.2288 66.3164Z"
        fill="white"
      />
      <path
        opacity="0.7"
        d="M19.0554 98.8178L43.5541 112.962L43.554 114.746L19.0554 98.8178Z"
        fill="#8B9DA2"
      />
      <path
        opacity="0.7"
        d="M73.41 97.1488L46.6548 113.785L46.5903 112.483L73.41 97.1488Z"
        fill="#8B9DA2"
      />
      <path
        d="M44.8084 69.7233C50.3667 68.9199 55.443 65.3409 58.686 60.8416C60.1983 58.7394 61.3124 56.3776 61.9728 53.8736C62.6742 51.5319 62.7895 49.0538 62.3088 46.6572C61.3081 42.6472 57.5977 40.2734 53.6754 39.7767C51.6852 39.5149 49.6614 39.7123 47.7592 40.3538C45.7868 41.0306 44.0757 42.3076 42.8655 44.0058C42.1067 44.9105 41.6294 46.0175 41.4923 47.1903C41.4807 47.6497 41.6426 48.0966 41.9459 48.4418C42.2491 48.787 42.6714 49.0052 43.1284 49.0529C44.3045 49.152 45.4799 48.8536 46.4664 48.2056C47.6693 47.5311 48.7287 46.6279 49.5852 45.5469C51.4224 43.2796 52.7971 40.674 53.6316 37.8777C54.2172 35.4782 54.2172 32.9731 53.6316 30.5737C53.1868 28.0636 52.0395 25.7311 50.3229 23.8466C48.3549 22.057 45.8576 20.957 43.2088 20.7132C40.5726 20.351 37.8883 20.6009 35.3643 21.4436C34.2556 21.7797 33.2285 22.3418 32.3477 23.0943C31.7196 23.6786 31.0038 24.6428 31.2594 25.5923C31.5151 26.5418 32.9028 26.9655 33.845 26.8413C35.2395 26.58 36.5169 25.8876 37.497 24.8619C38.5894 23.7865 39.5173 22.5559 40.2507 21.2099C40.7956 20.2425 41.0799 19.1502 41.076 18.0399C40.9811 13.4092 35.8609 10.4145 31.851 9.56722C30.7686 9.34108 29.6598 9.26734 28.5569 9.34811C28.1844 9.34811 28.4109 9.96165 28.7103 9.93974C30.8681 9.84168 33.0126 10.3261 34.9187 11.3421C36.7993 12.2065 38.3788 13.613 39.4545 15.3812C39.9339 16.253 40.1705 17.2375 40.1397 18.2319C40.1089 19.2263 39.8117 20.1942 39.2792 21.0346C38.564 22.2802 37.6736 23.4167 36.6352 24.409C35.766 25.1979 34.444 26.1109 33.2242 26.0232C33.0228 26.0228 32.8256 25.9657 32.6551 25.8585C32.4846 25.7513 32.3477 25.5983 32.2601 25.417C32.2233 25.1772 32.2431 24.932 32.3179 24.7012C32.3927 24.4704 32.5205 24.2603 32.691 24.0877C33.336 23.3931 34.1337 22.8579 35.021 22.5246C37.2122 21.6137 39.585 21.2237 41.9525 21.3852C44.3924 21.4293 46.7652 22.1915 48.7744 23.5764C50.5248 25.0297 51.7679 27.0018 52.3242 29.2078C53.0289 31.4488 53.248 33.8143 52.9669 36.1466C52.5332 38.4936 51.6315 40.7292 50.3156 42.7203C48.9643 44.9553 47.2698 47.1027 44.728 47.9792C44.0999 48.2056 42.7852 48.5343 42.5368 47.6213C42.2885 46.7083 43.0043 45.5835 43.4644 44.875C44.482 43.2735 45.9654 42.022 47.7154 41.2887C49.404 40.6119 51.2268 40.3368 53.04 40.4852C56.4802 40.7409 59.9715 42.5377 61.1694 45.956C61.7702 47.9989 61.8356 50.162 61.3593 52.2374C60.9296 54.5124 60.1118 56.6965 58.9416 58.6942C56.4247 62.9388 52.6128 66.2643 48.066 68.1822C46.985 68.6496 45.8747 69.0441 44.7426 69.4093C44.6258 69.4531 44.6769 69.7452 44.8084 69.7233Z"
        fill="#E0E0E0"
      />
      <path
        d="M21.5895 6.31028C18.6679 6.09846 14.6434 8.39924 16.075 10.0792C17.5066 11.7591 21.3047 9.04198 21.3047 9.04198C21.3047 9.04198 20.9468 12.4384 22.1884 12.8255C23.4301 13.2126 25.1101 9.9696 23.8684 7.89526C24.4672 8.13133 25.1159 8.21226 25.7544 8.13054C26.3929 8.04882 27.0003 7.80709 27.5204 7.4278C29.288 6.12768 27.4181 4.9006 24.9275 5.11972C24.9275 5.11972 26.7096 -0.723518 23.1088 0.394C21.3047 0.941804 20.6692 3.05268 21.5895 6.31028Z"
        fill="#232629"
      />
      <path
        d="M21.5895 6.31028C18.6679 6.09846 14.6434 8.39924 16.075 10.0792C17.5066 11.7591 21.3047 9.04198 21.3047 9.04198C21.3047 9.04198 20.9468 12.4384 22.1884 12.8255C23.4301 13.2126 25.1101 9.9696 23.8684 7.89526C24.4672 8.13133 25.1159 8.21226 25.7544 8.13054C26.3929 8.04882 27.0003 7.80709 27.5204 7.4278C29.288 6.12768 27.4181 4.9006 24.9275 5.11972C24.9275 5.11972 26.7096 -0.723518 23.1088 0.394C21.3047 0.941804 20.6692 3.05268 21.5895 6.31028Z"
        fill="#DCDCDC"
      />
      <path
        d="M24.3063 7.55211C24.1446 7.39382 23.9739 7.24505 23.795 7.10656C23.5393 6.90935 23.2691 6.71945 23.0134 6.52955C22.7645 6.34857 22.5034 6.18504 22.2319 6.04017C22.0756 5.95345 21.9147 5.87542 21.7498 5.80644C21.5222 5.69955 21.2691 5.65905 21.0194 5.68957C20.954 5.69142 20.8903 5.71081 20.835 5.74571C20.7796 5.78062 20.7347 5.82976 20.7048 5.88799C20.6749 5.94622 20.6613 6.0114 20.6652 6.07672C20.6692 6.14204 20.6906 6.20509 20.7273 6.25929C20.9281 6.47681 21.1787 6.64225 21.4577 6.74136L21.8521 6.95317C22.1224 7.11386 22.3634 7.29646 22.5825 7.47906C22.8016 7.66166 23.0938 7.83696 23.3129 8.01957C23.6897 8.32513 24.1108 8.57143 24.5619 8.74997C24.5821 8.76084 24.6047 8.76653 24.6276 8.76653C24.6506 8.76653 24.6732 8.76084 24.6934 8.74997C25.0659 8.45781 24.5181 7.76392 24.3063 7.55211Z"
        fill="#98ADB7"
      />
    </svg>
  );
}
